// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X-y1","rootNoMargin":"styles_rootNoMargin__2im23"};